module.exports = __webpack_public_path__ + "static/img/a105.febc0f39.png";